"use client";
import React from "react";
import SectionWrapper from "../wrapper/SectionWrapper";
import Image from "next/image";
import { ProjectProps } from "@/types/project/project.type";
import dynamic from "next/dynamic";
import AutomaticScrollingSkeleton from "../skeletons/AutomaticScrollingSkeleton";
import { useDict } from "@/components/providers/LocaleProvider";

const AutomaticScrolling = dynamic(() => import("./AutomaticScrolling"), {
  ssr: !!false,
  loading: () => <AutomaticScrollingSkeleton />,
});

const ProjectDetails = ({
  selectedProject,
}: {
  selectedProject: ProjectProps;
}) => {
  const t = useDict();
  return (
    <section className="space-y-8 lg:space-y-16">
      <AutomaticScrolling
        images={[
          ...(selectedProject?.images?.scroll || []),
          ...(selectedProject?.images?.scroll || []),
          ...(selectedProject?.images?.scroll || []),
        ]}
      />

      <SectionWrapper hideBottomPadding>
        <section className=" !px-[15%] bg-gradient-to-r from-background via-primary-dark to-background">
          <section className="">
            {selectedProject?.images?.mockup?.map((image, index) => (
              <section key={index} className="">
                <Image
                  src={image}
                  width={2000}
                  height={2000}
                  alt={`${t.projectDetail.mockupImageAlt} ${index + 1}`}
                  className="w-full object-cover"
                  loading="lazy"
                />
              </section>
            ))}
          </section>

          <section className="">
            {selectedProject?.images?.small?.map((image, index) => (
              <section key={index} className="">
                <Image
                  src={image}
                  width={2000}
                  height={2000}
                  alt={`${t.projectDetail.largeImageAlt} ${index + 1}`}
                  className="w-full object-cover object-top"
                  loading="lazy"
                />
              </section>
            ))}
          </section>

          <section className="">
            <Image
              src={selectedProject?.images?.landing || ""}
              width={2000}
              height={2000}
              alt={t.projectDetail.landingImageAlt}
              className="w-full h-full object-cover"
              loading="lazy"
            />
          </section>

          <section className="">
            {selectedProject?.images?.large?.map((image, index) => (
              <section key={index}>
                <Image
                  src={image}
                  width={2000}
                  height={2000}
                  alt={`${t.projectDetail.largeImageAlt} ${index + 1}`}
                  className="w-full object-cover object-top"
                />
              </section>
            ))}
          </section>
        </section>
      </SectionWrapper>
    </section>
  );
};

export default ProjectDetails;
